import api from '../api/axios.config';

export const assortmentService = {
  getStatusOptions: async () => {
    try {
      const response = await api.get(`/assortment/status-options`);
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getAssortmentData: async (page, page_size, status, columnFilters = {}) => {
    try {
      const params = { };

      if (status) params.status = status;
      if (page) params.page = page;
      if (page_size) params.page_size = page_size;

      Object.entries(columnFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      const response = await api.get(`/assortment/items`, { params });
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  getBranchesData: async (page, page_size, columnFilters = {}) => {
    try {
      const params = { };

      if (page) params.page = page;
      if (page_size) params.page_size = page_size;

      Object.entries(columnFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      const response = await api.get(`/assortment/branch-matrix`, { params });

      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  getPriceListData: async (page, page_size, columnFilters = {}) => {
    try {
      const params = { };

      if (page) params.page = page;
      if (page_size) params.page_size = page_size;

      Object.entries(columnFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      const response = await api.get(`/assortment/price-list`, { params });

      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  uploadPriceListExcel: async (rawFile, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', rawFile);

    try {
      const response = await api.post(
        `/uploads/price-list`,
        formData,
        {
          headers: {
            "Content-Type": rawFile.type,
            "X-Filename": rawFile.name
          },
          onUploadProgress,
        }
      );

      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  uploadSalesExcel: async (rawFile, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', rawFile);

    try {
      const response = await api.post(
        `/uploads/historical-sales-monthly`,
        formData,
        {
          headers: {
            "Content-Type": rawFile.type,
            "X-Filename": rawFile.name
          },
          onUploadProgress,
        }
      );
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  uploadBranchesExcel: async (rawFile, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', rawFile);

    try {
      const response = await api.post(
        `/uploads/branch-stock-norm`,
        formData,
        {
          headers: {
            "Content-Type": rawFile.type,
            "X-Filename": rawFile.name
          },
          onUploadProgress,
        }
      );
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  uploadAssortmentExcel: async (rawFile, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', rawFile);

    try {
      const response = await api.post(
        `/uploads/assortment`,
        formData,
        {
          headers: {
            "Content-Type": rawFile.type,
            "X-Filename": rawFile.name
          },
          onUploadProgress,
        }
      );
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  downloadExcelTemplatesZip: async () => {
    const response = await api.get(`/uploads/download-excel-templates-zip`, { responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'templates.zip';
    a.click();
    URL.revokeObjectURL(url);
  },

  groupBySkuForBranches: (branch_matrix) => {
    const map = {};

    branch_matrix.forEach(item => {
      const { sku_code, sku_name, mother_sku, branch_name, stock_norm } = item;

      if (!map[sku_code]) {
        map[sku_code] = { sku_code, sku_name, mother_sku };
      }

      map[sku_code][branch_name] = stock_norm;
    });

    return Object.values(map);
  },

  updateAssortmentStatus: async (sku_code, status) => {
    try{
      const response = await api.patch(
          `/assortment/items/status`,
          {
            updates: [
              {
                sku_code,
                status,
              },
            ],
          },
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },

  updateAssortmentNormDays: async (sku_code, general_stock_norm_days) => {
    try{
      const response = await api.patch(
          `/assortment/items`,
          {
            updates: [
              {
                sku_code,
                general_stock_norm_days,
              },
            ],
          },
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },

  updateBranchStock: async (sku_code, branch_name, stock_norm) => {
    try{
      const response = await api.patch(
          `/assortment/branch-matrix/stock-norm`,
          {
            updates: [
              {
                sku_code,
                branch_name,
                stock_norm
              },
            ],
          },
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },
  
  updatePriceList: async (sku_code, original_date, new_date, invoice_price, dsp) => {
    try{
      const response = await api.patch(
          `/assortment/price-list?sku_code=${sku_code}&date=${original_date}`,
          {
            new_date,
            invoice_price,
            dsp
          },
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },
};
